import React from 'react';
import IconButton from '@material-ui/core/IconButton';
import EditIcon from '@material-ui/icons/Edit';
import { useHistory } from 'react-router-dom';

export default function Columns() {
  const history = useHistory();
  return [
    {
      name: 'id',
      label: 'ID',
      options: {
        filter: false,
        sort: false,
        display: false,
      },
    },
    {
      name: 'title',
      label: 'Заголовок',
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: 'status',
      label: 'Статус',
      options: {
        filter: true,
        sort: false,
        customBodyRender: (value) => {
          if (value === 0) {
            return 'Невидимый';
          }
          if (value === 1) {
            return 'Видимый';
          }
          return 'Неизвестно';
        },
      },
    },
    {
      name: '',
      label: 'Управление',
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, tableMeta) => (
          <>
            <IconButton
              onClick={() => {
                const id = tableMeta.rowData[0];
                history.replace(`/admin/playlists/update/${id}`);
              }}
            >
              <EditIcon />
            </IconButton>
          </>
        ),
      },
    },
  ];
}
